import type { ReactNode } from 'react'
import { AppStatusState } from './AppStatusState'

export interface AppEmptyStateProps {
  readonly message: ReactNode
  readonly minHeight?: number | string
  readonly title?: ReactNode
}

export function AppEmptyState({
  message,
  minHeight,
  title = 'No content available yet',
}: AppEmptyStateProps) {
  return (
    <AppStatusState
      message={message}
      minHeight={minHeight}
      title={title}
      tone="empty"
    />
  )
}
